import React, { useState } from 'react';
import { Button } from 'reactstrap';

interface PasswordChangeTabProps {
  onPasswordChange: (password: string) => void;
}

export const PasswordChangeTab: React.FC<PasswordChangeTabProps> = ({
  onPasswordChange,
}) => {
  const [newPassword, setNewPassword] = useState('');

  const handlePasswordChange = () => {
    onPasswordChange(newPassword);
    setNewPassword('');
  };

  return (
    <div>
      <div className="input-group input-group-sm mb-2">
        <span className="input-group-text" id="inputGroup-sizing-sm">
          New Password
        </span>
        <input
          type="password"
          className="form-control"
          value={newPassword}
          onChange={(e) => setNewPassword(e.target.value)}
        />
      </div>
      <div className="input-group input-group-sm mb-3">
        <Button
          onClick={handlePasswordChange}
          color="danger"
          disabled={!newPassword}
        >
          Overwrite password
        </Button>
      </div>
    </div>
  );
};
